//JoinPage.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Spinner, Card, Button, Collapse, Row, Col, Badge, Container, Modal, Form } from "react-bootstrap";
//import { FaUserFriends, FaChevronDown, FaChevronUp } from "react-icons/fa";
import * as XLSX from "xlsx";
import { jwtDecode } from 'jwt-decode'; // 注意：您原本使用的 jwtDecode 可能需確認 import 是否正確
import axios from "./utils/axiosConfig";
import { isSuperAdmin } from "./utils/superAdmin";
import { useAuth } from "./context/AuthContext";


const JoinPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activityId = queryParams.get("aid"); // 取得活動編號

  const [employees, setEmployees] = useState([]); // 存儲社友資訊
  const [searchQuery, setSearchQuery] = useState(""); // 搜尋輸入框的值
  const [groupFilter, setGroupFilter] = useState("5"); // e_group過濾器，預設顯示社友(5)
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({registeredCount: 0,socialRegisteredCount: 0,leaveCount: 0,notRegisteredCount: 0,signedInCount:0, }); // 統計數據
  const [toastMessage, setToastMessage] = useState(null); // Toast 訊息狀態
  const [activityName, setActivityName] = useState(""); // Store the activity name
  const [questions, setQuestions] = useState([]); // 存儲問題和選項
  const { user } = useAuth();
  const [activityStartDate, setActivityStartDate] = useState(null); // 活動開始日期
  const [activityStopped, setActivityStopped] = useState(false); // 活動是否已異動停止報名
  const [registeredCount, setRegisteredCount] = useState(0); // 已報名人數
  const [activityPeopleLimit, setActivityPeopleLimit] = useState(0); // 活動人數限制
  const [activityLocation, setActivityLocation] = useState(''); // 活動地點

  // 問題填寫Modal相關狀態
  const [showQuestionsModal, setShowQuestionsModal] = useState(false);
  const [selectedEmployeeForQuestions, setSelectedEmployeeForQuestions] = useState(null);
  const [responses, setResponses] = useState({});
  
  // 統一權限檢查：超級管理員 (e_id=80) 或秘書 (e_position=17)
  const canEditRole = isSuperAdmin(user?.e_id) || user?.e_position === 17;
  
  // 檢查是否可以操作特定員工（包含家人關係）
  const canOperateEmployee = (emp) => {
    // 管理員和秘書可以操作所有人
    if (canEditRole) return true;
    
    // 社友(e_group=5)可以操作自己的家人(e_group=6且e_relation_uid=自己的e_id)
    if (user?.e_group === 5 && emp.e_group === 6 && emp.e_relation_uid === user.e_id) {
      return true;
    }
    
    return false;
  };
  
  // 檢查活動是否已開始
  const isActivityStarted = activityStartDate && new Date() >= new Date(activityStartDate);

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/activity-employees?aid=${activityId}&group=${groupFilter}`);
        const data = response.data;
          //console.log("Fetched Data:", data);
          // 設置社友資訊
          setActivityName(data.activityName);  // Set activity name
          setActivityStartDate(data.activityStartDate); // 設置活動開始日期
          setActivityStopped(data.activityStopped || false); // 設置活動異動狀態
          setActivityPeopleLimit(data.activityPeopleLimit || 0); // 設置活動人數限制
          setActivityLocation(data.activityLocation || ''); // 設置活動地點
          setEmployees(data.employees || []);
          setQuestions(data.questions || []); // 設置問題


          // 統計數據
          setStats({
            registeredCount: data.registeredCount || 0,
            socialRegisteredCount: data.socialRegisteredCount || 0,
            leaveCount: data.leaveCount || 0,
            notRegisteredCount: data.notRegisteredCount || 0,
            signedInCount: data.signedInCount || 0,
          });
          

          // data.employees.forEach((emp) => {
          //   if (emp.color === "blue") registeredCount += 1; // 社友已報名
          //   if (emp.color === "red") leaveCount += 1; // 社友請假
          //   if (emp.color === "black") notRegisteredCount += 1; // 社友未報名
          //   if (parseInt(emp.cardStatus, 10) === 10) signedInCount += 1; // 社友簽到

          //   // 包含家人報名
          //   emp.family?.forEach((fam) => {
          //     if (fam.color === "blue") {
          //       registeredCount += 1; // 家人已報名
          //       familyRegisteredCount += 1; // 統計家人報名數據
          //     }
          //   });
          // });

          // 計算社友報名數據
          //const employeeRegisteredCount = registeredCount - familyRegisteredCount;

          //setStats({ registeredCount, leaveCount, notRegisteredCount, signedInCount, socialRegisteredCount });
      } catch (error) {
        console.error('Error fetching employees:', error);
        setToastMessage('載入活動資料失敗');
      } finally {
        setLoading(false);
      }
    };

    if (activityId) {
      fetchEmployees();
    }
  }, [activityId, groupFilter]); // 依賴群組過濾器變化時重新載入

  const handleSearch = (e) => {
    setSearchQuery(e.target.value); // 更新搜尋輸入框的值
  };

  const handleGroupFilter = (e) => {
    setGroupFilter(e.target.value); // 更新群組過濾器的值
  };

  const filteredEmployees = employees.filter((emp) =>
    (emp.e_name || '').toLowerCase().includes(searchQuery.toLowerCase())
  ); // 過濾符合條件的社友
  
  const renderQuestionsAndResponses = (emp) => {
    return (
      <div className="mt-3">
        <h6 className="mb-2">問題與回應：</h6>
        {questions.map((question) => {
          const response = emp.responses.find((resp) => resp.q_id === question.q_id);
  
          return (
            <div key={question.q_id} className="mb-3">
              <p>
                <strong>問題：</strong> {question.q_text}
              </p>
              {question.q_type === 2 ? (
                <p>
                  <strong>回應：</strong>{" "}
                  {question.options.find((opt) => opt.o_id === response?.o_id)?.o_text || "尚未回應"}
                </p>
              ) : (
                <p>
                  <strong>回應：</strong> {response?.r_text || "尚未回應"}
                </p>
              )}
            </div>
          );
        })}
      </div>
    );
  };
  

  const exportToExcel = async (exportType = 'basic') => {
    let serialNumber = 1; // 初始化序號
    let employeeDetails = {};

    // 如果需要額外資訊且用戶具有權限，則取得員工詳細資料
    if (exportType !== 'basic' && canEditRole) {
      try {
        const response = await axios.get(`/activity-employees-details?aid=${activityId}&type=${exportType}`);
        employeeDetails = response.data.detailsData || {};
      } catch (error) {
        console.error('Error fetching employee details:', error);
      }
    }
  
    // 假設 employees 是資料陣列，questions 是活動問題
    const dataForExport = employees.flatMap((emp) => {
      // 每位員工的基本資料
      const empRow = {
        序號: serialNumber++, // 社友的序號
        社別: emp.store_name || "", // 社別名稱
        名稱: emp.e_name,
        社職: emp.position_name || "", // 職稱
        組別: emp.e_set || "", // 組別
        職位: emp.e_set_position || "", // 職位
        狀態: emp.color === "blue" ? (emp.cardStatus === 'checked_in' ? "已簽到" : "已報名") : emp.color === "red" ? "請假" : "未報名",
        報名時間: emp.registration_time
          ? new Date(emp.registration_time).toLocaleString()
          : "",
        簽到狀況:
          emp.cardStatus === "checked_in"
            ? "已簽到"
            : "未簽到",
        簽到時間: emp.cardTime
          ? new Date(emp.cardTime).toLocaleString()
          : "", // 如果有簽到時間，格式化時間；否則留空
      };
  
      // 動態添加問題與回應
      questions.forEach((question) => {
        const response = emp.responses.find((resp) => resp.q_id === question.q_id);
  
        // 若為選擇題，顯示選項內容；若為問答題，顯示回應文字
        empRow[`問題-${question.q_text}`] =
          question.q_type === 2
            ? question.options.find((opt) => opt.o_id === response?.o_id)?.o_text || "尚未回應"
            : response?.r_text || "尚未回應";
      });

      // 根據匯出類型添加對應欄位
      if (exportType !== 'basic' && employeeDetails[emp.e_id]) {
        const details = employeeDetails[emp.e_id];
        
        switch (exportType) {
          case 'mobile':
            empRow['行動電話'] = details.e_mobile || '';
            break;
          case 'insurance':
            empRow['ID（身分證字號）'] = details.e_UID || '';
            empRow['出生年月日'] = details.e_birthday || '';
            empRow['行動電話'] = details.e_mobile || '';
            break;
          case 'birthday':
            empRow['行動電話'] = details.e_mobile || '';
            empRow['出生年月日'] = details.e_birthday || '';
            break;
          case 'business':
            empRow['行動電話'] = details.e_mobile || '';
            empRow['公司名稱'] = details.e_comp_name || '';
            empRow['公司職位'] = details.e_comp_position || '';
            break;
        }
      }
  
      // 處理家人資料
      const familyRows = emp.family?.map((fam) => {
        const famRow = {
          序號: serialNumber++, // 家人的序號
          社別: fam.store_name || "", // 家人社別名稱
          名稱: fam.e_name,
          社職: fam.family_position_name || "", // 家人職稱
          組別: "", // 家人無組別
          職位: "", // 家人無職位
          狀態: fam.color === "blue" ? "已報名" : "未報名",
          報名時間: fam.registration_time
            ? new Date(fam.registration_time).toLocaleString()
            : "",
          簽到狀況: "", // 家人簽到狀況
          簽到時間: "", // 家人簽到時間
        };
  
        // 動態添加問題與回應（家人無回應，保持空值）
        questions.forEach((question) => {
          famRow[`問題-${question.q_text}`] = "";
        });

        // 根據匯出類型為家人添加對應空白欄位（家人通常沒有這些資料）
        if (exportType !== 'basic') {
          switch (exportType) {
            case 'mobile':
              famRow['行動電話'] = '';
              break;
            case 'insurance':
              famRow['ID（身分證字號）'] = '';
              famRow['出生年月日'] = '';
              famRow['行動電話'] = '';
              break;
            case 'birthday':
              famRow['行動電話'] = '';
              famRow['出生年月日'] = '';
              break;
            case 'business':
              famRow['行動電話'] = '';
              famRow['公司名稱'] = '';
              famRow['公司職位'] = '';
              break;
          }
        }
  
        return famRow;
      }) || [];
  
      return [empRow, ...familyRows];
    });
  
    // 將資料轉換為 Excel 表格
    const worksheet = XLSX.utils.json_to_sheet(dataForExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "活動報名情況");
  
    // 匯出 Excel
    XLSX.writeFile(workbook, `活動_${activityName}_報名情況.xlsx`);
  };

  // 處理Excel匯出按鈕點擊事件
  const handleExportClick = () => {
    if (canEditRole) {
      // 管理員和秘書權限：提供多種匯出選項
      const exportChoice = window.prompt(
        "請選擇匯出選項：\n\n" +
        "0 - 基本資訊（預設）\n" +
        "1 - 手機資訊（行動電話）\n" +
        "2 - 保險資訊（身分證字號 + 出生年月日 + 行動電話）\n" +
        "3 - 年會生日（行動電話 + 出生年月日）\n" +
        "4 - 工商參訪（行動電話 + 公司名稱 + 公司職位）\n\n" +
        "請輸入數字 0-4："
      );

      // 根據選擇決定匯出類型
      let exportType = 'basic';
      switch (exportChoice) {
        case '0':
          exportType = 'basic';
          break;
        case '1':
          exportType = 'mobile';
          break;
        case '2':
          exportType = 'insurance';
          break;
        case '3':
          exportType = 'birthday';
          break;
        case '4':
          exportType = 'business';
          break;
        default:
          if (exportChoice !== null) {
            alert('選項無效，將使用基本資訊匯出');
          } else {
            return; // 使用者取消
          }
          exportType = 'basic';
      }
      
      exportToExcel(exportType);
    } else {
      // 一般用戶：直接匯出基本資訊
      exportToExcel('basic');
    }
  };

  // 複製已簽到名單（姓名換行）
  const copyCheckedInNames = () => {
    // 篩選已簽到的人員
    const checkedInEmployees = employees.filter(emp => emp.cardStatus === 'checked_in');

    if (checkedInEmployees.length === 0) {
      setToastMessage({ type: 'error', text: '目前沒有已簽到的人員' });
      setTimeout(() => setToastMessage(null), 2000);
      return;
    }

    // 取得姓名並用換行符分隔
    const names = checkedInEmployees.map(emp => emp.e_name).join('\n');

    // 複製到剪貼簿
    navigator.clipboard.writeText(names).then(() => {
      setToastMessage({ type: 'success', text: `已複製 ${checkedInEmployees.length} 位簽到人員姓名` });
      setTimeout(() => setToastMessage(null), 2000);
    }).catch(err => {
      console.error('複製失敗:', err);
      setToastMessage({ type: 'error', text: '複製失敗，請手動選取' });
      setTimeout(() => setToastMessage(null), 2000);
    });
  };


  const renderEmployees = (employees) => {
  const sortedEmployees = [...employees].sort((a, b) => {
    const statusPriority = { blue: 1, red: 2, black: 3 };
    return (statusPriority[a.color] || 3) - (statusPriority[b.color] || 3);
  });

  return sortedEmployees.map((emp, index) => (
    <Card
      className={`mb-3 shadow-sm position-relative ${
        emp.color === "blue" ? "bg-info text-white" : 
        emp.color === "red" ? "bg-danger text-white" : "bg-white text-dark"
      }`}
      key={emp.e_id}
    >
      <Card.Body className="d-flex flex-column">
        {/* 照片置於右下角 */}
        <img
          src={
            emp.e_photo
              ? `/uploads/member/${emp.e_photo}`
              : "/uploads/member/default.jpg"
          }
          alt="社友相片"
          className="position-absolute"
          style={{
            bottom: "10px", // 將照片放置在底部
            right: "10px", // 照片置於右側
            width: "60px",
            height: "80px",
            borderRadius: "5px",
          }}
        />  
           <div>
          <h5>
            <Badge bg="secondary" className="me-2">
              {index + 1}
            </Badge>
            <span>
              {emp.e_mobile ? (
                <a
                  href={`tel:${emp.e_mobile}`}
                  style={{ textDecoration: "none" }}
                  className={emp.color === "blue" || emp.color === "red" ? "text-white" : "text-dark"}
                >
                  {emp.store_name && `${emp.store_name} `}{emp.e_name}
                </a>
              ) : (
                <>
                  {emp.store_name && `${emp.store_name} `}{emp.e_name}
                </>
              )}
              {/* 職稱、組別及組內職位根據狀態切換文字顏色 */}
          {emp.position_name && (
            <span className={emp.color === "blue" || emp.color === "red" ? "text-white" : "text-dark"}>
              -{emp.position_name}
            </span>
          )}
          {emp.e_set && (
            <span className={emp.color === "blue" || emp.color === "red" ? "text-white" : "text-dark"}>
              -{emp.e_set}
            </span>
          )}
          {emp.e_set_position && (
            <span className={emp.color === "blue" || emp.color === "red" ? "text-white" : "text-dark"}>
              -{emp.e_set_position}
            </span>
          )}
        </span>
        {/* 狀態顯示部分 - 根據活動是否開始顯示不同文字 */}
    {emp.color === "blue" && (
      <span
        className={emp.cardStatus === 'checked_in' ? "bg-success text-white ms-2 px-2 py-1 rounded" : "bg-primary text-white ms-2 px-2 py-1 rounded"}
        style={{ display: "inline-block" }}
      >
        {emp.cardStatus === 'checked_in' ? '已簽到' : '已報名'}
      </span>
    )}
    {emp.color === "red" && (
      <span
        className="bg-danger text-white ms-2 px-2 py-1 rounded"
        style={{ display: "inline-block" }}
      >
        已請假
      </span>
    )}
    {!emp.color && (
      <span
        className="bg-secondary text-white ms-2 px-2 py-1 rounded"
        style={{ display: "inline-block" }}
      >
        未報名
      </span>
    )}
  
          </h5>
          <span className={emp.color === "blue" || emp.color === "red" ? "text-white" : "text-dark"}>
            報名時間：
            {emp.registration_time
              ? new Date(emp.registration_time).toLocaleString()
              : "未報名"}
          </span>
          {renderQuestionsAndResponses(emp)}
          <p>
            {emp.cardStatus === 'checked_in'
              ? `簽到時間：${new Date(emp.cardTime).toLocaleString()}`
              : "未簽到"}
          </p>
          {canOperateEmployee(emp) && (
            <>
              {/* 檢查活動是否異動或報名人數是否已滿 */}
              {activityStopped && !canEditRole ? (
                <Badge bg="secondary">活動禁止異動</Badge>
              ) : (activityPeopleLimit > 0 && stats.socialRegisteredCount >= activityPeopleLimit && emp.color === "black" && !canEditRole) ? (
                <Badge bg="warning">人數已滿</Badge>
              ) : (
                <div className="d-flex gap-2">
                  <Button
                    variant={
                      isActivityStarted
                        ? (emp.cardStatus === 'checked_in' ? "secondary" : "success")
                        : (emp.color === "blue" ? "danger" : "primary")
                    }
                    onClick={() =>
                      isActivityStarted
                        ? handleCheckInClick(emp)
                        : handleParticipationClick({
                            ...emp,
                            a_id: activityId,
                          })
                    }
                    disabled={
                      (isActivityStarted && emp.cardStatus === 'checked_in')
                    }
                  >
                    {isActivityStarted
                      ? (emp.cardStatus === 'checked_in' ? "已簽到" : "協助簽到")
                      : (emp.color === "blue" ? "請假" : "報名")
                    }
                  </Button>

                  {/* 為已報名的員工顯示「填寫問題」按鈕 */}
                  {emp.color === "blue" && questions.length > 0 && (
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleQuestionsClick(emp)}
                    >
                      填寫問題
                    </Button>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </Card.Body>
    </Card>
  ));
};
  
  // Toast 訊息處理函數
  const showSuccessMessage = (message) => {
    setToastMessage({ type: 'success', text: message });
    setTimeout(() => setToastMessage(null), 2000); // 2秒後自動消失
  };

  const showErrorMessage = (message) => {
    setToastMessage({ type: 'error', text: message });
    setTimeout(() => setToastMessage(null), 3000); // 3秒後自動消失
  };

  // 秘書協助簽到功能
  const handleCheckInClick = async (employee) => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("請重新登入");
      return;
    }

    try {
      const response = await axios.post('/checkin/admin/checkin', {
        activityId: parseInt(activityId),
        employeeId: employee.e_id,
        storeId: employee.e_ssid,
        method: 'admin'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        // 更新本地狀態
        setEmployees((prevEmployees) =>
          prevEmployees.map((emp) =>
            emp.e_id === employee.e_id
              ? { 
                  ...emp, 
                  cardStatus: 'checked_in',
                  cardTime: new Date().toISOString()
                }
              : emp
          )
        );
        
        // 更新統計
        setStats(prev => ({
          ...prev,
          signedInCount: prev.signedInCount + 1
        }));
        
        // 顯示2秒自動消失的成功訊息
        showSuccessMessage(`${employee.e_name} 簽到成功！`);
      } else {
        showErrorMessage(response.data.error || '簽到失敗');
      }
    } catch (error) {
      console.error('協助簽到失敗:', error);
      showErrorMessage(error.response?.data?.error || '簽到失敗，請稍後再試');
    }
  };

  // 處理點擊「填寫問題」按鈕
  const handleQuestionsClick = async (employee) => {
    setSelectedEmployeeForQuestions(employee);
    setShowQuestionsModal(true);

    // 載入該員工的現有回應
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`/responses/${activityId}?targetEmployeeId=${employee.e_id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // 轉換現有回應為表單格式
      const existingResponses = {};
      response.data.forEach(resp => {
        if (resp.o_id) {
          existingResponses[resp.q_id] = resp.o_id;
        } else {
          existingResponses[resp.q_id] = resp.r_text;
        }
      });
      setResponses(existingResponses);
    } catch (error) {
      console.log('載入現有回應失敗:', error);
      // 如果載入失敗，重置為空物件
      setResponses({});
    }
  };

  // 處理問題回應變更
  const handleQuestionChange = (q_id, q_type, value) => {
    setResponses(prev => ({
      ...prev,
      [q_id]: value
    }));
  };

  // 提交問題回應
  const handleSubmitQuestions = async () => {
    if (!selectedEmployeeForQuestions || questions.length === 0) {
      setShowQuestionsModal(false);
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      showErrorMessage('請重新登入');
      return;
    }

    try {
      // 組合所有回答為一個陣列
      const answers = questions.map((q) => {
        const qType = Number(q.q_type);
        const answerValue = responses[q.q_id];
        if (qType === 1) {
          // 問答題
          return { q_id: q.q_id, r_text: answerValue || '' };
        } else {
          // 選擇題 (單選)
          return { q_id: q.q_id, o_id: answerValue };
        }
      });

      // 提交回應
      await axios.post('/responses/bulk', {
        a_id: activityId,
        e_id: selectedEmployeeForQuestions.e_id,
        answers
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowQuestionsModal(false);
      showSuccessMessage(`${selectedEmployeeForQuestions.e_name} 的問題填寫完成！`);
    } catch (error) {
      console.error('提交問題失敗:', error);
      showErrorMessage(error.response?.data?.message || '問題提交失敗，請稍後再試');
    }
  };

  const handleParticipationClick = async (activity) => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
  
    const decodedToken = jwtDecode(token);
    const { e_id } = decodedToken;

    // 檢查活動是否已異動且用戶不是管理者/秘書
    if (activityStopped && !canEditRole) {
      showErrorMessage('此活動禁止異動，目前無法進行任何報名或請假操作！');
      return;
    }

    // 檢查人數限制（只有未報名的一般用戶會被限制）
    if (activityPeopleLimit > 0 && stats.socialRegisteredCount >= activityPeopleLimit && 
        activity.color === "black" && !canEditRole) {
      showErrorMessage('報名人數已滿，無法進行報名！');
      return;
    }
  
    try {
      let updatedStatus = null;
  
      if (activity.color === "red") {
        // 狀態為請假，改成已報名
        await axios.put('/participation-update-status', {
          e_id: activity.e_id,
          a_id: activity.a_id,
          j_status: 0,
          editor: e_id,
        }, { headers: { Authorization: `Bearer ${token}` } });
  
        updatedStatus = "blue"; // 設定為已報名
      } else if (activity.color === "black") {
        // 狀態為未報名，執行報名動作
        await axios.post('/participation-register', {
          e_id: activity.e_id,
          a_id: activity.a_id,
          j_status: 0,
          editor: e_id,
        }, { headers: { Authorization: `Bearer ${token}` } });
  
        updatedStatus = "blue"; // 設定為已報名
      } else if (activity.color === "blue") {
        // 已報名 -> 轉請假
        await axios.put('/participation-update-status', {
          e_id: activity.e_id,
          a_id: activity.a_id,
          j_status: 1,
          editor: e_id,
        }, { headers: { Authorization: `Bearer ${token}` } });
  
        updatedStatus = "red"; // 設定為請假
      }
  
      // 更新本地狀態
      if (updatedStatus) {
        setEmployees((prevEmployees) =>
          prevEmployees.map((emp) =>
            emp.e_id === activity.e_id
              ? { ...emp, color: updatedStatus } // 更新顏色
              : emp
          )
        );
      }
    } catch (error) {
      // Error handling participation
    }
  };
  
  
  return (
    <Container className="mt-4 bg-dark text-light">
      {/* Toast 訊息組件 */}
      {toastMessage && (
        <div 
          className={`position-fixed top-0 start-50 translate-middle-x mt-3 alert ${
            toastMessage.type === 'success' ? 'alert-success' : 'alert-danger'
          } alert-dismissible fade show`}
          style={{ zIndex: 9999, minWidth: '300px' }}
          role="alert"
        >
          <strong>{toastMessage.type === 'success' ? '✅' : '❌'}</strong> {toastMessage.text}
        </div>
      )}
      
      <Card className="bg-dark text-light">
        <Card.Header className="bg-primary text-white text-center">
          <h2>活動報名</h2>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xs={12} className="text-center mb-3">
              <p>
                <strong>活動編號：</strong>
                {activityId} - {activityName}
              </p>
              {activityLocation && (
                <p>
                  <strong>地點：</strong>
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(activityLocation)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#17a2b8', textDecoration: 'underline' }}
                  >
                    {activityLocation}
                  </a>
                </p>
              )}
              {/* 活動異動狀態提示 */}
              {activityStopped && (
                <div className="alert alert-warning text-dark mt-2" role="alert">
                  <strong>⚠️ 注意：</strong>此活動禁止異動，目前無法進行任何報名或請假操作！
                  {canEditRole && <small className="d-block mt-1">（管理者和秘書不受此限制）</small>}
                </div>
              )}
              {/* 人數已滿狀態提示 */}
              {!activityStopped && activityPeopleLimit > 0 && stats.socialRegisteredCount >= activityPeopleLimit && (
                <div className="alert alert-info text-dark mt-2" role="alert">
                  <strong>ℹ️ 提示：</strong>此活動報名人數已滿！（{stats.socialRegisteredCount}/{activityPeopleLimit}）
                  {!canEditRole && <small className="d-block mt-1">（已報名者仍可請假）</small>}
                </div>
              )}
              </Col>
            <Col xs={12} className="text-center mb-3">
              <p>
                <strong>統計：</strong>{" "}
                已報名：{stats.registeredCount}| 社友已報名：{stats.socialRegisteredCount} | 請假：{stats.leaveCount} | 未報名：{stats.notRegisteredCount} | 已簽到：{stats.signedInCount}
              </p>
            </Col>
            <Col xs={12} className="text-center mb-3">
              <Button variant="success" onClick={handleExportClick} className="me-2">
                匯出 Excel
              </Button>
              <Button variant="info" onClick={copyCheckedInNames}>
                複製簽到名單
              </Button>
            </Col>
            <Col xs={12} md={6} className="text-center mb-3">
              <label className="form-label text-light">群組篩選：</label>
              <select
                value={groupFilter}
                onChange={handleGroupFilter}
                className="form-select"
              >
                <option value="5">社友</option>
                <option value="6">家人</option>
                <option value="7">來賓</option>
                <option value="8">顧問</option>
                <option value="all">全部</option>
              </select>
            </Col>
            <Col xs={12} md={6} className="text-center mb-3">
              <label className="form-label text-light">姓名搜尋：</label>
              <input
                type="text"
                placeholder="搜尋社友姓名"
                value={searchQuery}
                onChange={handleSearch}
                className="form-control"
              />
            </Col>
          </Row>
          {loading ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <Row>
              <Col xs={12}>
                <h4 className="text-center mb-4">社友列表</h4>
                {renderEmployees(filteredEmployees)}
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* 問題填寫 Modal */}
      <Modal
        show={showQuestionsModal}
        onHide={() => setShowQuestionsModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            為 {selectedEmployeeForQuestions?.e_name} 填寫問題
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {questions.length > 0 ? (
            <Form>
              {questions.map((question) => (
                <div key={question.q_id} className="mb-4">
                  <Form.Label className="fw-bold mb-2">
                    {question.q_text}
                    {question.q_type === 2 && <span className="text-danger"> *</span>}
                  </Form.Label>

                  {question.q_type === 1 ? (
                    // 問答題（文字輸入）
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="請輸入您的回答..."
                      value={responses[question.q_id] || ''}
                      onChange={(e) => handleQuestionChange(question.q_id, 1, e.target.value)}
                    />
                  ) : (
                    // 選擇題（單選）
                    <div>
                      {question.options.map((option) => (
                        <Form.Check
                          key={option.o_id}
                          type="radio"
                          id={`q${question.q_id}_o${option.o_id}`}
                          name={`question_${question.q_id}`}
                          label={option.o_text}
                          checked={responses[question.q_id] === option.o_id}
                          onChange={() => handleQuestionChange(question.q_id, 2, option.o_id)}
                          className="mb-2"
                        />
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </Form>
          ) : (
            <p className="text-center text-muted">此活動沒有設定問題</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowQuestionsModal(false)}
          >
            取消
          </Button>
          {questions.length > 0 && (
            <Button
              variant="primary"
              onClick={handleSubmitQuestions}
            >
              確認提交
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default JoinPage;
